import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container footer__container">
        <p className="footer__text">&copy; {year} TenantVerify SA. All rights reserved.</p>
        <div className="footer__links">
          <Link to="/terms" className="footer__link">Terms</Link>
          <Link to="/privacy" className="footer__link">Privacy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
